import styled from 'styled-components'

export const Card = styled.div`
    border: 1px solid lightgrey;
    border-radius: 8px;
    padding: 0 8px;
    height: 100%;
    .cardName p {
        font-size: 18px;
        text-align: center;
        color: dimgray;
    }
    .cardContent {
        p {
            font-size: 13px;
            text-align: center;
            color: dimgray;
        }
    }
    .cardBtn {
        padding: 14px 0;
        text-align: center;
    }
    .cardBtn:last-child {
        padding-bottom: 14px;
    }
    .cardBtn Button {
        border-radius: 7px;
        border: 1px solid darkgrey;
        font-weight: 600;
        color: #1e77eb;
    }
`
